import { QuoteCreateButton } from "./quote.create.button";
import { QuoteCreateForm } from "./quote.create.form";

export const QuoteCreate = {
    Button: QuoteCreateButton,
    Component: QuoteCreateForm,
}
